(function() {
    'use strict';

    function injectFormStyles() {
        var selectors = [
            '#app-embed[data-form-root="true"]',
            '#app-embed',
            '[data-form-root="true"]',
            'div[data-form-root]',
            '[class*="_appEmbedRoot_"]'
        ];

        var appEmbed = null;
        for (var i = 0; i < selectors.length; i++) {
            appEmbed = document.querySelector(selectors[i]);
            if (appEmbed) break;
        }

        if (!appEmbed || !appEmbed.shadowRoot) return false;
        var shadowRoot = appEmbed.shadowRoot;

        if (shadowRoot.querySelector('#corporate-form-custom-styles')) return true;

        var styleElement = document.createElement('style');
        styleElement.id = 'corporate-form-custom-styles';
        styleElement.textContent = `

            /* --- Outer form container --- */
            [class*="_formContainer_"] {
                padding: 0 20px !important;
                box-sizing: border-box !important;
            }

            [class*="_gridItem_"][class*="_imageLoading_"] {
                display: none !important;
            }

            [class*="_gridItem_"][class*="_gridItemContent_"] {
                width: 100% !important;
                max-width: 900px !important;
                margin: 0 auto !important;
                padding: 40px 0 !important;
            }

            /* --- Grid Layout --- */
            [class*="_formFieldset_"] {
                display: grid !important;
                grid-template-columns: 1fr 1fr !important;
                gap: 24px 20px !important;
                max-width: 100% !important;
            }

            .corporate-form-full-width {
                grid-column: 1 / -1 !important;
            }

            [class*="_formFieldset_"] > div:has(shop-lead-capture),
            [class*="_formFieldset_"] > div:has(script) {
                display: none !important;
            }

            /* --- Input Fields --- */
            [class*="_formFieldContainer_"] {
                width: 100% !important;
                min-width: 0 !important;
                position: relative !important;
            }

            [class*="_formInputField_"]:not([class*="_formPhoneInputField_"]) {
                width: 100% !important;
                box-sizing: border-box !important;
                font-family: 'Mulish', 'Muli', sans-serif !important;
                font-size: 15px !important;
                color: #162950 !important;
                background: #fff !important;
                border: 1.5px solid #d1d5db !important;
                border-radius: 6px !important;
                padding: 14px 16px !important;
                transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
                outline: none !important;
            }

            [class*="_formInputField_"]:focus {
                border-color: #37487D !important;
                box-shadow: 0 0 0 3px rgba(55, 72, 125, 0.1) !important;
            }

            [class*="_formInputField_"]:hover:not(:focus) {
                border-color: #9ca3af !important;
            }

            /* --- Phone Input --- */
            [class*="_formPhoneInputContainer_"] {
                display: flex !important;
                align-items: stretch !important;
                gap: 8px !important;
                width: 100% !important;
                grid-column: 1 / -1 !important;
            }

            [class*="_formPhoneInputContainer_"] .phone-country-selector {
                flex-shrink: 0 !important;
            }

            [class*="_formPhoneInputContainer_"] .phone-country-selector [class*="_selectContainer_"] {
                width: auto !important;
            }

            [class*="_formPhoneInputContainer_"] .phone-country-selector [class*="_selectToggle_"] {
                width: auto !important;
                min-width: 70px !important;
                padding: 14px 10px !important;
                border: 1.5px solid #d1d5db !important;
                border-radius: 6px !important;
                background: #fff !important;
                height: 100% !important;
                box-sizing: border-box !important;
            }

            [class*="_formPhoneInputContainer_"] [class*="_formFieldContainer_"] {
                flex: 1 !important;
                min-width: 0 !important;
            }

            [class*="_formPhoneInputField_"] {
                width: 100% !important;
                box-sizing: border-box !important;
                font-family: 'Mulish', 'Muli', sans-serif !important;
                font-size: 15px !important;
                color: #162950 !important;
                background: #fff !important;
                border: 1.5px solid #d1d5db !important;
                border-radius: 6px !important;
                padding: 14px 16px !important;
                transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
                outline: none !important;
            }

            [class*="_formPhoneInputField_"]:focus {
                border-color: #37487D !important;
                box-shadow: 0 0 0 3px rgba(55, 72, 125, 0.1) !important;
            }

            /* --- Labels --- */
            [class*="_formInputFieldLabel_"] {
                font-family: 'Spartan', sans-serif !important;
                font-size: 13px !important;
                font-weight: 500 !important;
                color: #37487D !important;
                letter-spacing: 0.02em !important;
                transition: all 0.2s ease !important;
            }

            /* --- Textarea --- */
            [class*="_textArea_"] {
                width: 100% !important;
                box-sizing: border-box !important;
                font-family: 'Mulish', 'Muli', sans-serif !important;
                font-size: 15px !important;
                color: #162950 !important;
                background: #fff !important;
                border: 1.5px solid #d1d5db !important;
                border-radius: 6px !important;
                padding: 14px 16px !important;
                min-height: 100px !important;
                resize: vertical !important;
                transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
                outline: none !important;
            }

            [class*="_textArea_"]:focus {
                border-color: #37487D !important;
                box-shadow: 0 0 0 3px rgba(55, 72, 125, 0.1) !important;
            }

            [class*="_textArea_"]:hover:not(:focus) {
                border-color: #9ca3af !important;
            }

            /* --- Standalone Dropdowns (not phone country picker) --- */
            [class*="_formFieldset_"] > [class*="_selectContainer_"] {
                width: 100% !important;
            }

            [class*="_selectContainer_"] [class*="_label_"]:not([class*="_formInputFieldLabel_"]) {
                font-family: 'Spartan', sans-serif !important;
                font-size: 13px !important;
                font-weight: 500 !important;
                color: #37487D !important;
                margin-bottom: 6px !important;
                letter-spacing: 0.02em !important;
            }

            [class*="_formFieldset_"] > [class*="_selectContainer_"] > [class*="_selectToggle_"] {
                width: 100% !important;
                box-sizing: border-box !important;
                font-family: 'Mulish', 'Muli', sans-serif !important;
                font-size: 15px !important;
                color: #162950 !important;
                background: #fff !important;
                border: 1.5px solid #d1d5db !important;
                border-radius: 6px !important;
                padding: 14px 16px !important;
                text-align: left !important;
                cursor: pointer !important;
                transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
            }

            [class*="_selectToggle_"]:hover {
                border-color: #9ca3af !important;
            }

            [class*="_selectToggle_"]:focus,
            [class*="_selectToggle_"][aria-expanded="true"] {
                border-color: #37487D !important;
                box-shadow: 0 0 0 3px rgba(55, 72, 125, 0.1) !important;
                outline: none !important;
            }

            [class*="_arrowDownIcon_"] svg path {
                fill: #37487D !important;
            }

            /* --- Submit Button --- */
            [data-testid="btn-form-submit"] {
                font-family: 'Oswald', sans-serif !important;
                font-size: 16px !important;
                font-weight: 500 !important;
                letter-spacing: 2px !important;
                text-transform: uppercase !important;
                background: #37487D !important;
                color: #fff !important;
                border: none !important;
                border-radius: 6px !important;
                padding: 16px 48px !important;
                cursor: pointer !important;
                transition: background-color 0.2s ease, transform 0.05s ease !important;
                margin-top: 8px !important;
                justify-self: center !important;
            }

            [data-testid="btn-form-submit"]:hover {
                background: #172950 !important;
            }

            [data-testid="btn-form-submit"]:active {
                transform: scale(0.98) !important;
            }

            /* --- Disclaimer --- */
            [class*="_formDisclaimer_"] {
                font-family: 'Mulish', 'Muli', sans-serif !important;
                font-size: 12px !important;
                color: #6D6D6D !important;
                text-align: center !important;
            }

            [class*="_formDisclaimer_"] a {
                color: #37487D !important;
                text-decoration: underline !important;
            }

            /* --- Error states --- */
            [aria-invalid="true"] {
                border-color: #dc2626 !important;
                box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.08) !important;
            }

            /* --- Mobile --- */
            @media (max-width: 768px) {
                [class*="_formContainer_"] {
                    padding: 0 20px !important;
                }

                [class*="_gridItem_"][class*="_gridItemContent_"] {
                    padding: 24px 0 !important;
                }

                [class*="_formFieldset_"] {
                    grid-template-columns: 1fr !important;
                    gap: 18px !important;
                    padding: 0 !important;
                    margin: 0 !important;
                }

                .corporate-form-full-width {
                    grid-column: 1 !important;
                }

                [class*="_formPhoneInputContainer_"] {
                    grid-column: 1 !important;
                }

                [class*="_formInputField_"],
                [class*="_formPhoneInputField_"],
                [class*="_textArea_"],
                [class*="_formFieldset_"] > [class*="_selectContainer_"] > [class*="_selectToggle_"] {
                    font-size: 16px !important;
                    padding: 12px 14px !important;
                }

                [data-testid="btn-form-submit"] {
                    width: 100% !important;
                    padding: 14px 24px !important;
                }

                [class*="_formPhoneInputContainer_"] {
                    gap: 6px !important;
                }
            }
        `;

        shadowRoot.insertBefore(styleElement, shadowRoot.firstChild);
        addFullWidthClasses(shadowRoot);
        return true;
    }

    function addFullWidthClasses(shadowRoot) {
        var shopLeadCapture = shadowRoot.querySelector('shop-lead-capture');
        if (shopLeadCapture) {
            var scriptWrapper = shopLeadCapture.parentElement;
            if (scriptWrapper && scriptWrapper.parentElement &&
                scriptWrapper.parentElement.matches('[class*="_formFieldset_"]')) {
                scriptWrapper.style.display = 'none';
            }
        }

        var fieldset = shadowRoot.querySelector('[class*="_formFieldset_"]');
        if (fieldset) {
            var children = fieldset.children;
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                if (child.tagName === 'DIV' &&
                    !child.matches('[class*="_formFieldContainer_"]') &&
                    !child.matches('[class*="_formPhoneInputContainer_"]') &&
                    !child.matches('[class*="_selectContainer_"]') &&
                    child.querySelector('script, shop-lead-capture')) {
                    child.style.display = 'none';
                }
            }
        }

        var emailField = shadowRoot.querySelector('input[id="email"]');
        if (emailField) {
            var container = emailField.closest('[class*="_formFieldContainer_"]');
            if (container) container.classList.add('corporate-form-full-width');
        }

        var companyField = shadowRoot.querySelector('input[id="custom#company"]');
        if (companyField) {
            var container = companyField.closest('[class*="_formFieldContainer_"]');
            if (container) container.classList.add('corporate-form-full-width');
        }

        var productsField = shadowRoot.querySelector('input[id="custom#which_products_are_you_interested_in"]');
        if (productsField) {
            var container = productsField.closest('[class*="_formFieldContainer_"]');
            if (container) container.classList.add('corporate-form-full-width');
        }

        var textarea = shadowRoot.querySelector('textarea');
        if (textarea) {
            var container = textarea.closest('[class*="_formFieldContainer_"]');
            if (container) container.classList.add('corporate-form-full-width');
        }

        var phoneContainer = shadowRoot.querySelector('[class*="_formPhoneInputContainer_"]');

        if (phoneContainer) {
            phoneContainer.classList.add('corporate-form-full-width');
        }

        shadowRoot.querySelectorAll('[class*="_formFieldset_"] > [class*="_selectContainer_"]').forEach(function(el) {
            if (!phoneContainer || !phoneContainer.contains(el)) {
                el.classList.add('corporate-form-full-width');
            }
        });

        var submitButton = shadowRoot.querySelector('[data-testid="btn-form-submit"]');
        if (submitButton) submitButton.classList.add('corporate-form-full-width');

        var disclaimer = shadowRoot.querySelector('[class*="_formDisclaimer_"]');
        if (disclaimer) disclaimer.classList.add('corporate-form-full-width');
    }

    function waitForFormAndInjectStyles() {
        var attempts = 0;
        var maxAttempts = 50;

        var checkInterval = setInterval(function() {
            attempts++;
            if (injectFormStyles()) {
                clearInterval(checkInterval);
            } else if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
            }
        }, 150);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForFormAndInjectStyles);
    } else {
        waitForFormAndInjectStyles();
    }

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) {
                    if (node.id === 'app-embed' ||
                      (node.querySelector && node.querySelector('#app-embed')) ||
                      (node.hasAttribute && node.hasAttribute('data-form-root'))) {
                        setTimeout(waitForFormAndInjectStyles, 500);
                    }
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();
